<div class="container-full has-background-white-bis mb-8">
  <div class="container">
    <div class="columns">
      <div class="column">
        <app-breadcrumb></app-breadcrumb>
      </div>
    </div>
  </div>
</div>

<ng-container *ngIf="favoriteIncentiveIds">
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <div class="field has-addons">
          <p class="control mb-0 mb-4">
            <a
              class="button is-small is-white-ter is-hidden-desktop mb-0 mr-2"
              routerLink="/incentives"
              [queryParams]="savedFilters"
            >
              <span class="icon is-small">
                <i class="fa-solid fa-arrow-left"></i>
              </span>
            </a>
            <a
              class="button is-white-ter is-hidden-touch"
              routerLink="/incentives"
              [queryParams]="savedFilters"
            >
              <span class="icon is-small">
                <i class="fa-solid fa-arrow-left"></i>
              </span>
              <span>Modify selection</span>
            </a>
          </p>
        </div>
        <nav class="level is-flex">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">
              <h1 class="title is-2 has-text-weight-bold has-line">
                Comparison of R&D Tax Incentives
              </h1>
            </div>
          </div>

          <!-- Right side -->
          <div class="level-right is-flex">
            <div class="level-item">
              <div class="field has-addons">
                <p class="control">
                  <a class="button is-small is-link-light is-hidden-desktop">
                    <span class="icon is-small">
                      <i class="fa-solid fa-file-export"></i>
                    </span>
                  </a>
                  <a
                    class="button is-link-light is-hidden-touch"
                    [ngClass]="{
                      'is-loading': loadingDownload
                    }"
                    (click)="downloadIncentives(favoriteIncentiveIds)"
                  >
                    <span>Export incentives</span>
                    <span class="icon is-small">
                      <i class="fa-solid fa-file-export"></i>
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </nav>
        <p>
          This interactive interface allows you to view and compare key features
          of several R&D tax incentives at a glance, and find incentives with
          similar features.
        </p>
      </div>
    </div>
  </div>

  <app-incentive-comparator
    [isOrderable]="true"
    [allowDeleteIncentive]="true"
    [showAdviceIfEmpty]="true"
    [incentiveIds]="favoriteIncentiveIds"
    (orderChanged)="onOrderChanged($event)"
  ></app-incentive-comparator>
</ng-container>
